export default __webpack_public_path__ + "static/media/start_.f3446f2a.svg";